// extracted by mini-css-extract-plugin
export default {"carousel-container":"Carousel_carousel-container__axzcd","carousel-item":"Carousel_carousel-item__pDFes"};